import { getD2DChannelContentPromise, updateD2DChannelContentPromise } from "../apiPromise/channel";
import { getD2DResultInfoPromise } from "../apiPromise/result";

class d2dChannelConstructor {
  constructor() {
    this.channelList = new Map();
    this.resultChannelList = new Map();
  }

  setInfo = (id, list) => {
    this.channelList.set(id, list)
  }

  add = (list) => {
    for (let item of list) {
      this.channelList.set(item.id, item)
    }
  }

  setResultInfo = (id, list) => {
    this.resultChannelList.set(id, list)
  }

  getChannelContentPromise = (channelId, isNew) => {
    return new Promise((resolve, reject) => {
      const info = this.channelList.get(channelId);
      if (info && !isNew) {
        resolve(JSON.parse(JSON.stringify(info)));
      } else {
        getD2DChannelContentPromise(channelId).then(res => {
          if (res) {
            this.setInfo(channelId, { ...res })
            resolve(res);
          } else {
            resolve(null);
          }
        }, error => {
          console.error(error);
          resolve(null);
        })
      }
    })
  }

  updateChannelContent = (obj) => {
    const { id, content } = obj;
    return new Promise((resolve, reject) => {
      updateD2DChannelContentPromise({ d2dChannelId: id, content }).then(res => {
        if (res) {
          this.setInfo(id, { ...res })
          resolve(res);
        } else {
          resolve(null);
        }
      }, error => {
        console.error(error);
        resolve(null);
      })
    })
  }

  get = (id) => {
    return this.channelList.get(id)
  }

  delete = (id) => {
    this.channelList.delete(id)
  }

  getChannelResultContentPromise = (channelId, isNew) => {
    return new Promise((resolve, reject) => {
      const info = this.resultChannelList.get(channelId);
      if (info && !isNew) {
        resolve(JSON.parse(JSON.stringify(info)));
      } else {
        getD2DResultInfoPromise(channelId, "verification_json").then(res => {
          if (res) {
            this.setResultInfo(channelId, { ...res })
            resolve(res);
          } else {
            resolve(null);
          }
        }, error => {
          console.error(error);
          resolve(null);
        })
      }
    })
  }

  getResultInfo = (id) => {
    return this.resultChannelList.get(id)
  }

  clearAll = () => {
    this.channelList = new Map();
    this.resultChannelList = new Map();
  }
}

let D2DChannelConstructor = new d2dChannelConstructor();
export default D2DChannelConstructor;